export default __webpack_public_path__ + "static/media/mt-pallet.b7b14ca6.svg";